
const state = {
    isLogisticInversed: false,
}

const mutations = {
    'CHANGE_LOGISTIC' (state, isLogisticInversed) {
        state.isLogisticInversed = isLogisticInversed
    }
}

const getters = {
    isLogisticInversed () {
        return this.state.isLogisticInversed
    }
}


export default {
    state,
    mutations,
    getters
}
